import React from 'react';
import Tooltip from '@mui/material/Tooltip';
import { HIconButton, MenuDropdown } from 'BaseComponents';
import { Person } from '@mui/icons-material';


const UserTools = ({ items }) => {
  const [anchorEl, setAnchorEl] = React.useState();
  const open = Boolean(anchorEl);

  return (
    <>
      <HIconButton data-testid='face-button-logout' onClick={e => setAnchorEl(e.currentTarget)} active={open.toString()}>
        <Tooltip title='Profile' placement='bottom'>
          <Person />
        </Tooltip>
      </HIconButton>
      <MenuDropdown
        handleClose={() => setAnchorEl(null)}
        anchor={anchorEl}
        open={open}
        items={items}
      />
    </>
  );
};

export default UserTools;
